import React, { forwardRef } from 'react'

export const Link = forwardRef(function Link({ className, children, ...props }, ref) {
  return (
    <a ref={ref} className={className} {...props}>
      {children}
    </a>
  )
})
